module.exports = __webpack_public_path__ + "img/video-ar.7df1d69d.svg";